export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const SIGN_UP = 'SIGN_UP';
export const REFRESH_SUCCESS = 'REFRESH_SUCCESS';
export const REFRESH_FAIL = 'REFRESH_FAIL';
export const FETCH_ME = 'FETCH_ME';
export const EDIT_ME = 'EDIT_ME';
export const FETCH_BUSINESS = 'FETCH_BUSINESS';
export const EDIT_BUSINESS = 'EDIT_BUSINESS';
export const FETCH_USERS = 'FETCH_USERS';
export const UPDATE_USER = 'UDATE_USER';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const SHOW_ERROR = 'SHOW_ERROR';
export const HIDE_ERROR = 'HIDE_ERROR';
export const VERIFY_EMAIL = 'VERIFY_EMAIL';
export const ADD_EMPLOYEE = 'ADD_EMPLOYEE';
export const EDIT_EMPLOYEE = 'EDIT_EMPLOYEE';
export const DELETE_EMPLOYEE = 'DELETE_EMPLOYEE';
export const FETCH_EMPLOYEES = 'FETCH_EMPLOYEES';
export const ADD_PREMISES = 'ADD_PREMISES';
export const EDIT_PREMISES = 'EDIT_PREMISES';
export const DELETE_PREMISES = 'DELETE_PREMISES';
export const FETCH_PREMISES_LIST = 'FETCH_PREMISES_LIST';
export const SUBMIT_START_SURVEY = 'SUBMIT_START_SURVEY';
export const CHECK_START_SURVEY = 'CHECK_START_SURVEY';
export const ADD_CONSULTANT = 'ADD_CONSULTANT'
export const EDIT_CONSULTANT = 'EDIT_CONSULTANT'
export const DELETE_CONSULTANT = 'DELETE_CONSULTANT'
export const FETCH_CONSULTANTS = 'FETCH_CONSULTANTS'
export const ADD_PURCHASE = 'ADD_PURCHASE'
export const EDIT_PURCHASE = 'EDIT_PURCHASE'
export const DELETE_PURCHASE = 'DELETE_PURCHASE'
export const FETCH_PURCHASES = 'FETCH_PURCHASES'
export const ADD_LEASING = 'ADD_LEASING'
export const EDIT_LEASING = 'EDIT_LEASING'
export const DELETE_LEASING = 'DELETE_LEASING'
export const FETCH_LEASINGS = 'FETCH_LEASINGS'
export const ADD_RENTAL = 'ADD_RENTAL'
export const EDIT_RENTAL = 'EDIT_RENTAL'
export const DELETE_RENTAL = 'DELETE_RENTAL'
export const FETCH_RENTALS = 'FETCH_RENTALS'
export const ADD_MATERIAL = 'ADD_MATERIAL'
export const EDIT_MATERIAL = 'EDIT_MATERIAL'
export const DELETE_MATERIAL = 'DELETE_MATERIAL'
export const FETCH_MATERIALS = 'FETCH_MATERIALS'
export const ADD_PRODUCTION_VOLUME = 'ADD_PRODUCTION_VOLUME'
export const EDIT_PRODUCTION_VOLUME = 'EDIT_PRODUCTION_VOLUME'
export const DELETE_PRODUCTION_VOLUME = 'DELETE_PRODUCTION_VOLUME'
export const FETCH_PRODUCTION_VOLUMES = 'FETCH_PRODUCTION_VOLUMES'
export const ADD_LOAN = 'ADD_LOAN'
export const EDIT_LOAN = 'EDIT_LOAN'
export const DELETE_LOAN = 'DELETE_LOAN'
export const FETCH_LOANS = 'FETCH_LOANS'
export const ADD_DIGITAL_AD = 'ADD_DIGITAL_AD'
export const EDIT_DIGITAL_AD = 'EDIT_DIGITAL_AD'
export const DELETE_DIGITAL_AD = 'DELETE_DIGITAL_AD'
export const FETCH_DIGITAL_ADS = 'FETCH_DIGITAL_ADS'
export const ADD_EVENT = 'ADD_EVENT'
export const EDIT_EVENT = 'EDIT_EVENT'
export const DELETE_EVENT = 'DELETE_EVENT'
export const FETCH_EVENTS = 'FETCH_EVENTS'
export const ADD_MARKET_RESEARCH = 'ADD_MARKET_RESEARCH'
export const EDIT_MARKET_RESEARCH = 'EDIT_MARKET_RESEARCH'
export const DELETE_MARKET_RESEARCH = 'DELETE_MARKET_RESEARCH'
export const FETCH_MARKET_RESEARCH = 'FETCH_MARKET_RESEARCH'
export const ADD_BRANDING_PROJECT = 'ADD_BRANDING_PROJECT'
export const EDIT_BRANDING_PROJECT = 'EDIT_BRANDING_PROJECT'
export const DELETE_BRANDING_PROJECT = 'DELETE_BRANDING_PROJECT'
export const FETCH_BRANDING_PROJECTS = 'FETCH_BRANDING_PROJECTS'
export const ADD_SERVICE = 'ADD_SERVICE'
export const EDIT_SERVICE = 'EDIT_SERVICE'
export const DELETE_SERVICE = 'DELETE_SERVICE'
export const FETCH_SERVICES = 'FETCH_SERVICES'

export const FETCH_COST_REPORT = 'FETCH_COST_REPORT'
export const FETCH_COST_REPORT_DETAILED = 'FETCH_COST_REPORT_DETAILED'

export const ADD_SURVEY = 'ADD_SURVEY'
export const FETCH_SURVEYS = 'FETCH_SURVEYS'
export const FETCH_SURVEY = 'FETCH_SURVEY'
export const TAKE_SURVEY = 'TAKE_SURVEY'
export const ANSWER_SURVEY = 'ANSWER_SURVEY'
export const START_SURVEY = 'START_SURVEY'
export const ANALYZE_SURVEY = 'ANALYZE_SURVEY'
export const FETCH_TEST_SURVEY = 'FETCH_TEST_SURVEY'
export const EDIT_SURVEY_DESIGN = 'EDIT_SURVEY_DESIGN'
export const ADD_SURVEY_RESPONDENT = 'ADD_SURVEY_RESPONDENT'
export const EDIT_SURVEY_RESPONDENT = 'EDIT_SURVEY_RESPONDENT'
export const DELETE_SURVEY_RESPONDENT = 'DELETE_SURVEY_RESPONDENT'
export const ADD_FIRMOGRAPHIC = 'ADD_FIRMOGRAPHIC'
export const FETCH_FIRMOGRAPHICS = 'FETCH_FIRMOGRAPHICS'
export const FETCH_FIRMOGRAPHIC = 'FETCH_FIRMOGRAPHIC'
export const TOGGLE_FIRMOGRAPHIC_READY = 'TOGGLE_FIRMOGRAPHIC_READY'
export const ADD_FIRMOGRAPHIC_QUESTION = 'ADD_FIRMOGRAPHIC_QUESTION'
export const EDIT_FIRMOGRAPHIC_QUESTION = 'EDIT_FIRMOGRAPHIC_QUESTION'
export const MOVE_FIRMOGRAPHIC_QUESTION = 'MOVE_FIRMOGRAPHIC_QUESTION'
export const DELETE_FIRMOGRAPHIC_QUESTION = 'DELETE_FIRMOGRAPHIC_QUESTION'
export const ADD_CONJOINT = 'ADD_CONJOINT'
export const ADD_CONJOINT_ATTRIBUTE = 'ADD_CONJOINT_ATTRIBUTE'
export const EDIT_CONJOINT_ATTRIBUTE = 'EDIT_CONJOINT_ATTRIBUTE'
export const MOVE_CONJOINT_ATTRIBUTE = 'MOVE_CONJOINT_ATTRIBUTE'
export const FETCH_CONJOINTS = 'FETCH_CONJOINTS'
export const FETCH_CONJOINT = 'FETCH_CONJOINT'
export const TOGGLE_CONJOINT_READY = 'TOGGLE_CONJOINT_READY'
export const DELETE_CONJOINT_ATTRIBUTE = 'DELETE_CONJOINT_ATTRIBUTE'
export const EDIT_CONJOINT_PRICES = 'EDIT_CONJOINT_PRICES'
export const ADD_CONJOINT_EXCLUSION = 'ADD_CONJOINT_EXCLUSION'
export const EDIT_CONJOINT_EXCLUSION = 'EDIT_CONJOINT_EXCLUSION'
export const DELETE_CONJOINT_EXCLUSION = 'DELETE_CONJOINT_EXCLUSION'
export const EDIT_CONJOINT_SETTINGS = 'EDIT_CONJOINT_SETTINGS'
export const FETCH_CONJOINT_PREVIEW = 'FETCH_CONJOINT_PREVIEW'
export const ADD_GABOR_GRANGER = 'ADD_GABOR_GRANGER'
export const FETCH_GABOR_GRANGERS = 'FETCH_GABOR_GRANGERS'
export const FETCH_GABOR_GRANGER = 'FETCH_GABOR_GRANGER'
export const TOGGLE_GABOR_GRANGER_READY = 'TOGGLE_GABOR_GRANGER_READY'
export const EDIT_GABOR_GRANGER_PRICES = 'EDIT_GABOR_GRANGER_PRICES'
export const EDIT_GABOR_GRANGER_PRODUCT = 'EDIT_GABOR_GRANGER_PRODUCT'
export const EDIT_GABOR_GRANGER_SETTINGS = 'EDIT_GABOR_GRANGER_SETTINGS'
export const FETCH_GABOR_GRANGER_PREVIEW = 'FETCH_GABOR_GRANGER_PREVIEW'
export const ADD_VAN_WESTENDORP = 'ADD_VAN_WESTENDORP'
export const FETCH_VAN_WESTENDORPS = 'FETCH_VAN_WESTENDORPS'
export const FETCH_VAN_WESTENDORP = 'FETCH_VAN_WESTENDORP'
export const TOGGLE_VAN_WESTENDORP_READY = 'TOGGLE_VAN_WESTENDORP_READY'
export const EDIT_VAN_WESTENDORP_PRODUCT = 'EDIT_VAN_WESTENDORP_PRODUCT'
export const EDIT_VAN_WESTENDORP_SETTINGS = 'EDIT_VAN_WESTENDORP_SETTINGS'

export const FETCH_COST_VALUE_DRIVER = 'FETCH_COST_VALUE_DRIVER'
export const ADD_VALUE_MODEL = 'ADD_VALUE_MODEL' 
export const FETCH_VALUE_MODEL = 'FETCH_VALUE_MODEL'
export const FETCH_VALUE_MODELS = 'FETCH_VALUE_MODELS'
export const FETCH_IMPACT_ANALYSIS = 'FETCH_IMPACT_ANALYSIS'
export const ADD_IMPACT_AREA = 'ADD_IMPACT_AREA'
export const EDIT_IMPACT_ANALYSIS = 'EDIT_IMPACT_ANALYSIS'
export const FETCH_DRIVER_ANALYSIS = 'FETCH_DRIVER_ANALYSIS'
export const EDIT_REVENUE_MODEL = 'EDIT_REVENUE_MODEL'
export const ADD_COST_VALUE_DRIVER_LABOR = 'ADD_COST_VALUE_DRIVER_LABOR'
export const EDIT_COST_VALUE_DRIVER_LABOR = 'EDIT_COST_VALUE_DRIVER_LABOR'
export const DELETE_COST_VALUE_DRIVER_LABOR = 'DELETE_COST_VALUE_DRIVER_LABOR'
export const ADD_COST_VALUE_DRIVER_CS = 'ADD_COST_VALUE_DRIVER_CS'
export const EDIT_COST_VALUE_DRIVER_CS = 'EDIT_COST_VALUE_DRIVER_CS'
export const DELETE_COST_VALUE_DRIVER_CS = 'DELETE_COST_VALUE_DRIVER_CS'
export const ADD_COST_VALUE_DRIVER_OPERATING = 'ADD_COST_VALUE_DRIVER_OPERATING'
export const EDIT_COST_VALUE_DRIVER_OPERATING = 'EDIT_COST_VALUE_DRIVER_OPERATING'
export const DELETE_COST_VALUE_DRIVER_OPERATING = 'DELETE_COST_VALUE_DRIVER_OPERATING'

export const ADD_COST_VALUE_DRIVER_ACCOUNTING = 'ADD_COST_VALUE_DRIVER_ACCOUNTING'
export const EDIT_COST_VALUE_DRIVER_ACCOUNTING = 'EDIT_COST_VALUE_DRIVER_ACCOUNTING'
export const DELETE_COST_VALUE_DRIVER_ACCOUNTING = 'DELETE_COST_VALUE_DRIVER_ACCOUNTING'
export const ADD_COST_VALUE_DRIVER_HR = 'ADD_COST_VALUE_DRIVER_HR'
export const EDIT_COST_VALUE_DRIVER_HR = 'EDIT_COST_VALUE_DRIVER_HR'
export const DELETE_COST_VALUE_DRIVER_HR = 'DELETE_COST_VALUE_DRIVER_HR'
export const ADD_COST_VALUE_DRIVER_BD = 'ADD_COST_VALUE_DRIVER_BD'
export const EDIT_COST_VALUE_DRIVER_BD = 'EDIT_COST_VALUE_DRIVER_BD'
export const DELETE_COST_VALUE_DRIVER_BD = 'DELETE_COST_VALUE_DRIVER_BD'
export const ADD_COST_VALUE_DRIVER_MARCOM = 'ADD_COST_VALUE_DRIVER_MARCOM'
export const EDIT_COST_VALUE_DRIVER_MARCOM = 'EDIT_COST_VALUE_DRIVER_MARCOM'
export const DELETE_COST_VALUE_DRIVER_MARCOM = 'DELETE_COST_VALUE_DRIVER_MARCOM'
export const ADD_COST_VALUE_DRIVER_CUSTOMER_SUCCESS = 'ADD_COST_VALUE_DRIVER_CUSTOMER_SUCCESS'
export const EDIT_COST_VALUE_DRIVER_CUSTOMER_SUCCESS = 'EDIT_COST_VALUE_DRIVER_CUSTOMER_SUCCESS'
export const DELETE_COST_VALUE_DRIVER_CUSTOMER_SUCCESS = 'DELETE_COST_VALUE_DRIVER_CUSTOMER_SUCCESS'
export const ADD_COST_VALUE_DRIVER_IT = 'ADD_COST_VALUE_DRIVER_IT'
export const EDIT_COST_VALUE_DRIVER_IT = 'EDIT_COST_VALUE_DRIVER_IT'
export const DELETE_COST_VALUE_DRIVER_IT = 'DELETE_COST_VALUE_DRIVER_IT'
export const ADD_COST_VALUE_DRIVER_LEGAL = 'ADD_COST_VALUE_DRIVER_LEGAL'
export const EDIT_COST_VALUE_DRIVER_LEGAL = 'EDIT_COST_VALUE_DRIVER_LEGAL'
export const DELETE_COST_VALUE_DRIVER_LEGAL = 'DELETE_COST_VALUE_DRIVER_LEGAL'
export const ADD_COST_VALUE_DRIVER_PROCUREMENT = 'ADD_COST_VALUE_DRIVER_PROCUREMENT'
export const EDIT_COST_VALUE_DRIVER_PROCUREMENT = 'EDIT_COST_VALUE_DRIVER_PROCUREMENT'
export const DELETE_COST_VALUE_DRIVER_PROCUREMENT = 'DELETE_COST_VALUE_DRIVER_PROCUREMENT'

export const ADD_COST_VALUE_DRIVER_RANDD = 'ADD_COST_VALUE_DRIVER_RANDD'
export const EDIT_COST_VALUE_DRIVER_RANDD = 'EDIT_COST_VALUE_DRIVER_RANDD'
export const DELETE_COST_VALUE_DRIVER_RANDD = 'DELETE_COST_VALUE_DRIVER_RANDD'
export const ADD_COST_VALUE_DRIVER_INVESTMENT = 'ADD_COST_VALUE_DRIVER_INVESTMENT'
export const EDIT_COST_VALUE_DRIVER_INVESTMENT = 'EDIT_COST_VALUE_DRIVER_INVESTMENT'
export const DELETE_COST_VALUE_DRIVER_INVESTMENT = 'DELETE_COST_VALUE_DRIVER_INVESTMENT'
export const ADD_COST_VALUE_DRIVER_COMPLIANCE = 'ADD_COST_VALUE_DRIVER_COMPLIANCE'
export const EDIT_COST_VALUE_DRIVER_COMPLIANCE = 'EDIT_COST_VALUE_DRIVER_COMPLIANCE'
export const DELETE_COST_VALUE_DRIVER_COMPLIANCE = 'DELETE_COST_VALUE_DRIVER_COMPLIANCE'
export const ADD_COST_VALUE_DRIVER_PAYMENT = 'ADD_COST_VALUE_DRIVER_PAYMENT'
export const EDIT_COST_VALUE_DRIVER_PAYMENT = 'EDIT_COST_VALUE_DRIVER_PAYMENT'
export const DELETE_COST_VALUE_DRIVER_PAYMENT = 'DELETE_COST_VALUE_DRIVER_PAYMENT'

export const ADD_COST_VALUE_DRIVER_INVENTORY = 'ADD_COST_VALUE_DRIVER_INVENTORY'
export const EDIT_COST_VALUE_DRIVER_INVENTORY = 'EDIT_COST_VALUE_DRIVER_INVENTORY'
export const DELETE_COST_VALUE_DRIVER_INVENTORY = 'DELETE_COST_VALUE_DRIVER_INVENTORY'
export const ADD_COST_VALUE_DRIVER_FACILITY = 'ADD_COST_VALUE_DRIVER_FACILITY'
export const EDIT_COST_VALUE_DRIVER_FACILITY = 'EDIT_COST_VALUE_DRIVER_FACILITY'
export const DELETE_COST_VALUE_DRIVER_FACILITY = 'DELETE_COST_VALUE_DRIVER_FACILITY'
export const ADD_COST_VALUE_DRIVER_EQUIPMENT = 'ADD_COST_VALUE_DRIVER_EQUIPMENT'
export const EDIT_COST_VALUE_DRIVER_EQUIPMENT = 'EDIT_COST_VALUE_DRIVER_EQUIPMENT'
export const DELETE_COST_VALUE_DRIVER_EQUIPMENT = 'DELETE_COST_VALUE_DRIVER_EQUIPMENT'
export const ADD_COST_VALUE_DRIVER_UPGRADE = 'ADD_COST_VALUE_DRIVER_UPGRADE'
export const EDIT_COST_VALUE_DRIVER_UPGRADE = 'EDIT_COST_VALUE_DRIVER_UPGRADE'
export const DELETE_COST_VALUE_DRIVER_UPGRADE = 'DELETE_COST_VALUE_DRIVER_UPGRADE'
export const ADD_REVENUE_VALUE_DRIVER_TTM = 'ADD_REVENUE_VALUE_DRIVER_TTM'
export const EDIT_REVENUE_VALUE_DRIVER_TTM = 'EDIT_REVENUE_VALUE_DRIVER_TTM'
export const DELETE_REVENUE_VALUE_DRIVER_TTM = 'DELETE_REVENUE_VALUE_DRIVER_TTM'
export const ADD_REVENUE_VALUE_DRIVER_SALES = 'ADD_REVENUE_VALUE_DRIVER_SALES'
export const EDIT_REVENUE_VALUE_DRIVER_SALES = 'EDIT_REVENUE_VALUE_DRIVER_SALES'
export const DELETE_REVENUE_VALUE_DRIVER_SALES = 'DELETE_REVENUE_VALUE_DRIVER_SALES'
export const ADD_REVENUE_VALUE_DRIVER_MARKETING = 'ADD_REVENUE_VALUE_DRIVER_MARKETING'
export const EDIT_REVENUE_VALUE_DRIVER_MARKETING = 'EDIT_REVENUE_VALUE_DRIVER_MARKETING'
export const DELETE_REVENUE_VALUE_DRIVER_MARKETING = 'DELETE_REVENUE_VALUE_DRIVER_MARKETING'
export const ADD_REVENUE_VALUE_DRIVER_CLV = 'ADD_REVENUE_VALUE_DRIVER_CLV'
export const EDIT_REVENUE_VALUE_DRIVER_CLV = 'EDIT_REVENUE_VALUE_DRIVER_CLV'
export const DELETE_REVENUE_VALUE_DRIVER_CLV = 'DELETE_REVENUE_VALUE_DRIVER_CLV'
export const ADD_REVENUE_VALUE_DRIVER_IR = 'ADD_REVENUE_VALUE_DRIVER_IR'
export const EDIT_REVENUE_VALUE_DRIVER_IR = 'EDIT_REVENUE_VALUE_DRIVER_IR'
export const DELETE_REVENUE_VALUE_DRIVER_IR = 'DELETE_REVENUE_VALUE_DRIVER_IR'
export const ADD_RISK_VALUE_DRIVER_REGULATORY = 'ADD_RISK_VALUE_DRIVER_REGULATORY'
export const EDIT_RISK_VALUE_DRIVER_REGULATORY = 'EDIT_RISK_VALUE_DRIVER_REGULATORY'
export const DELETE_RISK_VALUE_DRIVER_REGULATORY = 'DELETE_RISK_VALUE_DRIVER_REGULATORY'
export const ADD_RISK_VALUE_DRIVER_LITIGATION = 'ADD_RISK_VALUE_DRIVER_LITIGATION'
export const EDIT_RISK_VALUE_DRIVER_LITIGATION = 'EDIT_RISK_VALUE_DRIVER_LITIGATION'
export const DELETE_RISK_VALUE_DRIVER_LITIGATION = 'DELETE_RISK_VALUE_DRIVER_LITIGATION'
export const ADD_RISK_VALUE_DRIVER_REVENUE = 'ADD_RISK_VALUE_DRIVER_REVENUE'
export const EDIT_RISK_VALUE_DRIVER_REVENUE = 'EDIT_RISK_VALUE_DRIVER_REVENUE'
export const DELETE_RISK_VALUE_DRIVER_REVENUE = 'DELETE_RISK_VALUE_DRIVER_REVENUE'
export const EDIT_VARIABLE_VALUES = 'EDIT_VARIABLE_VALUES'
export const VIEW_VALUE_MODEL = 'VIEW_VALUE_MODEL'
export const CLEAR_COST_VALUE_DRIVER = 'CLEAR_COST_VALUE_DRIVER'
export const QUERY_COST_ITEM = "QUERY_COST_ITEM"
export const QUERY_COST_TYPE = "QUERY_COST_TYPE"
export const QUERY_EMPLOYEE_TYPE = "QUERY_EMPLOYEE_TYPE"
export const QUERY_EMPLOYEE_CATEGORY = "QUERY_EMPLOYEE_CATEGORY"
export const QUERY_INVESTMENT_PROJECT = "QUERY_INVESTMENT_PROJECT"
export const QUERY_INVESTMENT_ASSET = "QUERY_INVESTMENT_ASSET"
export const QUERY_PRODUCT_TYPE = "QUERY_PRODUCT_TYPE"
export const QUERY_REVENUE_TYPE = "QUERY_REVENUE_TYPE"
export const CLEAR_QUERY_RESULT = "CLEAR_QUERY_RESULT"
export const ADD_DATA = "ADD_DATA"

export const ADD_PRODUCT = 'ADD_PRODUCT'
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS'
export const EDIT_PRODUCT = 'EDIT_PRODUCT'

export const ADD_PRESENTATION = 'ADD_PRESENTATION'
export const FETCH_PRESENTATIONS = 'FETCH_PRESENTATIONS'
export const EDIT_PRESENTATION = 'EDIT_PRESENTATION'
export const ADD_CUSTOMER_SEGMENT = 'ADD_CUSTOMER_SEGMENT'
export const EDIT_CUSTOMER_SEGMENT = 'EDIT_CUSTOMER_SEGMENT'
export const DELETE_CUSTOMER_SEGMENT = 'DELETE_CUSTOMER_SEGMENT'

export const INIT_INTERVIEW = 'INIT_INTERVIEW';
export const RECORD_ANSWER = 'RECORD_ANSWER';
export const FETCH_METRIC_STEP_START = 'FETCH_METRIC_STEP_START';
export const FETCH_METRIC_STEP_SUCCESS = 'FETCH_METRIC_STEP_SUCCESS';
export const FETCH_METRIC_STEP_ERROR = 'FETCH_METRIC_STEP_ERROR';
export const FETCH_PERSONNEL_STEP_START = 'FETCH_PERSONNEL_STEP_START';
export const FETCH_PERSONNEL_STEP_SUCCESS = 'FETCH_PERSONNEL_STEP_SUCCESS';
export const FETCH_PERSONNEL_STEP_ERROR = 'FETCH_PERSONNEL_STEP_ERROR';
export const FETCH_OPERATIONAL_STEP_START = 'FETCH_OPERATIONAL_STEP_START';
export const FETCH_OPERATIONAL_STEP_SUCCESS = 'FETCH_OPERATIONAL_STEP_SUCCESS';
export const FETCH_OPERATIONAL_STEP_ERROR = 'FETCH_OPERATIONAL_STEP_ERROR';